import { render, staticRenderFns } from "./FormVerify.vue?vue&type=template&id=42b10980&"
import script from "./FormVerify.vue?vue&type=script&lang=js&"
export * from "./FormVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports